import * as React from 'react';
import classnames from 'classnames';
import { SubscriptionContainer } from '../containers/SubscriptionContainer.js';
import { useCartSlots } from '../../../slots/context.js';
import { Subtotal } from '../components/Subtotal.js';
import { CartDiscount } from '../components/CartDiscount.js';
import { RemoveVoucherCodeContainer } from '../../VoucherCodes/RemoveVoucherCode/RemoveVoucherCodeContainer.js';
import { PaymentMethodPrice } from '../components/PaymentMethodPrice.js';
import { Shipping } from '../components/Shipping.js';
import { MainTotal } from '../components/MainTotal.js';
import { SubscriptionHeader } from '../components/SubscriptionHeader.js';

const Mixed = ({ className , currency , labels , lineItems , prices , settings , subscription , voucherCodes , hideSubscriptionExplainer  })=>{
    const { Slots  } = useCartSlots();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cart-totals', className)
    }, settings.showSubTotal && /*#__PURE__*/ React.createElement(Subtotal, {
        label: labels.subTotal,
        price: prices.subTotalPrice,
        currency: currency
    }), settings.showTotalDiscount && prices.discountPrice !== 0 && /*#__PURE__*/ React.createElement(CartDiscount, {
        label: labels.totalDiscount,
        price: -prices.discountPrice,
        currency: currency
    }), voucherCodes === null || voucherCodes === void 0 ? void 0 : voucherCodes.map((code)=>/*#__PURE__*/ React.createElement(RemoveVoucherCodeContainer, {
            key: code,
            voucherCode: code
        })
    ), prices.paymentMethodPrice && /*#__PURE__*/ React.createElement(PaymentMethodPrice, {
        label: labels.paymentMethodPrice,
        price: prices.paymentMethodPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(Shipping, {
        labels: labels,
        price: prices.shippingPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(MainTotal, {
        label: labels.todaysTotal,
        price: prices.totalPrice,
        currency: currency
    }), Slots.AfterTotals ? /*#__PURE__*/ React.createElement(Slots.AfterTotals, null) : null, /*#__PURE__*/ React.createElement(SubscriptionHeader, {
        header: labels.subscriptionHeader
    }), /*#__PURE__*/ React.createElement(SubscriptionContainer, {
        lineItems: lineItems,
        subscription: subscription,
        hideSubscriptionExplainer: hideSubscriptionExplainer
    }));
};

export { Mixed };
//# sourceMappingURL=Mixed.js.map
